<template>
  <div v-if="visible" class="currtop">
    <el-breadcrumb separator-class="el-icon-arrow-right" v-show="show">
      <el-breadcrumb-item
        v-for="item in options"
        :key="item.title"
        :to="{ path: item.url }"
        >{{ item.title }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  name: "Breadcrumb",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data: function () {
    return {
      show: this.options.length !== 0,
    };
  },
};
</script>
<style>
.currtop {
  height: 66px;
  line-height: 66px;
}
.currtop .el-breadcrumb {
  font-size: 14px;
  line-height: 66px;
  font-family: PingFangSC-Regular;
}
.currtop .is-link {
  font-size: 14px !important;
  color: #8f98b9;
  font-family: PingFangSC-Regular;
}
.currtop .el-breadcrumb__item:last-child {
  color: #2e334a !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue